import {
  FORM_FIELDS,
  VALIDATION_TYPES,
  VALIDATION_PARAMS,
  VALIDATION_FIELD_PREFIXES,
  VALIDATION_MESSAGES,
} from '../constants';

export const FIELD_VALIDATION_RULES = {
  [FORM_FIELDS.FIRST_NAME]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.FIRST_NAME_REQUIRED,
    },
  },
  [FORM_FIELDS.LAST_NAME]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.LAST_NAME_REQUIRED,
    },
  },
  [FORM_FIELDS.EMAIL]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.EMAIL],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.EMAIL_REQUIRED,
      [VALIDATION_TYPES.EMAIL]: VALIDATION_MESSAGES.EMAIL_INVALID,
    },
  },
  [FORM_FIELDS.USERNAME]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.MIN_LENGTH, VALIDATION_TYPES.ALPHANUMERIC],
    params: { [VALIDATION_TYPES.MIN_LENGTH]: VALIDATION_PARAMS.USERNAME_MIN_LENGTH },
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.USERNAME_REQUIRED,
      [VALIDATION_TYPES.MIN_LENGTH]: VALIDATION_MESSAGES.USERNAME_MIN_LENGTH,
      [VALIDATION_TYPES.ALPHANUMERIC]: VALIDATION_MESSAGES.USERNAME_FORMAT,
    },
  },
  [FORM_FIELDS.EE_CODE]: {
    required: false,
    validators: [VALIDATION_TYPES.EE_CODE_FORMAT],
    messages: {
      [VALIDATION_TYPES.EE_CODE_FORMAT]: VALIDATION_MESSAGES.EE_CODE_FORMAT,
    },
  },
  [FORM_FIELDS.JOB_ROLE]: {
    required: false,
    validators: [],
    messages: {},
  },
  [FORM_FIELDS.SUPERVISOR_ID]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.SUPERVISOR_REQUIRED,
    },
  },
  [FORM_FIELDS.TEMP_USER]: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.TEMP_USER_REQUIRED,
    },
  },
};

export const LICENSE_VALIDATION_RULES = {
  license_number: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.LICENSE_FORMAT],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.LICENSE_NUMBER_REQUIRED,
      [VALIDATION_TYPES.LICENSE_FORMAT]: VALIDATION_MESSAGES.LICENSE_FORMAT,
    },
  },
  license_expiration: {
    required: true,
    validators: [VALIDATION_TYPES.REQUIRED, VALIDATION_TYPES.FUTURE_DATE],
    messages: {
      [VALIDATION_TYPES.REQUIRED]: VALIDATION_MESSAGES.LICENSE_EXPIRATION_REQUIRED,
      [VALIDATION_TYPES.FUTURE_DATE]: VALIDATION_MESSAGES.LICENSE_EXPIRED,
    },
  },
};

export const getLicenseFieldRules = (stateCode) => ({
  [`${VALIDATION_FIELD_PREFIXES.LICENSE_NUMBER}${stateCode}`]: LICENSE_VALIDATION_RULES.license_number,
  [`${VALIDATION_FIELD_PREFIXES.LICENSE_EXPIRATION}${stateCode}`]: LICENSE_VALIDATION_RULES.license_expiration,
});

export const EDIT_MODE_SKIP_FIELDS = [FORM_FIELDS.USERNAME];
